import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import withRouter from "../../services/utils/withRouter";
import { Outlet } from "react-router-dom";
import {
  copyFromDesign,
  trackAdminAction,
  loadVariationWithOverride,
  design
} from "../../actions";
import queryString from "query-string";

class ProductContainer extends Component {
  componentDidMount() {
    const {
      location,
      params,
      loadVariationWithOverride,
      trackAdminAction,
      design,
      copyFromDesign
    } = this.props;
    const query = queryString.parse(location.search);

    if (query && query.override) {
      loadVariationWithOverride({
        id: params.id,
        override: query.override
      });
    }

    if (query && query.action) {
      let payload = {
        actionType: query.action,
        orderID: query.orderID,
        orderNumber: query.orderNumber,
        orderItemID: query.orderItemID,
        purchasedItemID: query.purchasedItemID,
        return: query.return
      };
      trackAdminAction(payload);
    }

    // Check if design is an upsell product
    if (query && query.copyFromDesign) {
      const { nocontent } = query;
      design({
        designId: params.id,
        copyFromDesignId: query.copyFromDesign,
        nocontent
      });
    } else {
      // This is the main "load design" call when first starting
      design({
        designId: params.id
      });
    }

    // Check if copying a design to another product
    if (query && query.copyFrom) {
      copyFromDesign({
        copyId: query.copyFrom
      });
    }

    if (process.env.NODE_ENV === "production") {
      window.addEventListener("beforeunload", this.onUnload);
    }
  }

  componentWillUnmount() {
    if (process.env.NODE_ENV === "production") {
      window.removeEventListener("beforeunload", this.onUnload);
    }
  }

  // Prompt user before reloading or leaving the site
  onUnload = (event) => {
    if (!this.props.isRedirecting) {
      event.preventDefault();
      event.returnValue = "You have an unsaved design. Are you sure?";
    }
  };

  render() {
    return (
      <div className="product-route-container">
        <Outlet />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isRedirecting: state.design.present.isRedirecting,
    copyFromDesignId: state.copyFromDesignId.designId
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      copyFromDesign,
      loadVariationWithOverride,
      trackAdminAction,
      design: design.request
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProductContainer));
